"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'autofocus',
    'disabled',
    'form',
    'formaction',
    'formenctype',
    'formmethod',
    'formnovalidate',
    'formtarget',
    'name',
    'type',
    'value',
]);
//# sourceMappingURL=button.js.map